import StepDemo from "@dashboard/modules/shared/components/onboarding-shared/pages/step-demo/step-demo";
import { FC } from "react";

const OnboardingDemo: FC = () => {
  return <StepDemo ctaNextStep="generating" />;
};

export default OnboardingDemo;